import React, { Component } from "react";
import { HStack } from "native-base";

import { View, TouchableHighlight, ScrollView, Platform } from "react-native";
import Text from "../../components_v2/TextFont";

import { translate } from "../../locales/translate";

import * as AppActions from "../../actions/AppActions";
import * as UserActions from "../../actions/UserActions";
import arTheme from "../../argon-ui/Theme";

import * as CONSTS from "../../../assets/consts";
import { connect } from "react-redux";
import { Badge } from "react-native-material-bottom-navigation";
import AlertDialogBase from "../../nativeBase-ui/AlertDialog";
import MultiLanguage from "../../components_v2/MultiLanguage";
import { getDir, getIsRTL } from "../../util";
import * as faCharCodes from "../../../assets/consts/faCharCodes";
import { IconButton } from "../../components_v2/Buttons";

const IS_MOBILE = Platform.OS == "android" || Platform.OS == "ios";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

class SettingsListScreen extends Component {
  constructor(props) {
    super(props);

    let hasNewUpdate =
      this.props.navigation.state != undefined &&
      this.props.navigation.state.params != undefined
        ? this.props.navigation.state.params.hasNewUpdate
        : false;

    this.state = {
      serverIP: "",
      fullName: "",
      isShowingLogoutAlert: false,
      isShowingCloseSessionAlert: false,
      sessionIdToClose: null,
      hasNewUpdate,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.Setting"),
  });
  componentDidMount() {
    this.checkServerUrl();
    this.setState({
      fullName: this.props.appReducer.currentServer.userFullName,
    });
    // SecureStore.getItemAsync(CONSTS.USER_FULL_NAME)
    //   .then((fullName) => this.setState({ fullName }))
    //   .catch(console.log);
    this.props.userReducer.sessions = null;
    this.props.GetUserSessions(
      this.props.appReducer?.currentServer.accessToken
    );
  }

  showLogoutConfirm() {
    this.setState({ isShowingLogoutAlert: true });
  }
  hideLogoutConfirm() {
    this.setState({ isShowingLogoutAlert: false });
  }

  showCloseSessionConfirm(sessionId) {
    if (sessionId != null) {
      this.setState({
        isShowingCloseSessionAlert: true,
        sessionIdToClose: sessionId,
      });
    }
  }
  hideCloseSessionConfirm() {
    this.setState({
      isShowingCloseSessionAlert: false,
      sessionIdToClose: null,
    });
  }
  async closeSession() {
    this.hideCloseSessionConfirm();
    if (this.state.sessionIdToClose != null) {
      this.props.CloseUserSessions(
        this.props.appReducer?.currentServer.accessToken,
        this.state.sessionIdToClose
      );
      await delay(5000);
      this.props.GetUserSessions(
        this.props.appReducer?.currentServer.accessToken
      );
    }
  }

  checkServerUrl = (
    serverInfo = undefined,
    buildingId = null,
    addressConnected = ""
  ) => {
    var _serverIP = this.state.serverIP;
    if (_serverIP.endsWith("/")) {
      _serverIP = _serverIP.slice(0, -1);
    }
    var newServerUrl = addressConnected || serverInfo?.publicAddress;
    if (newServerUrl && newServerUrl.endsWith("/")) {
      newServerUrl = newServerUrl.slice(0, -1);
    }
    const currentServerAddress = this.props.appReducer?.serverUrl;
    this.setState({ serverIP: currentServerAddress });

    if (newServerUrl && newServerUrl !== _serverIP) {
      this.setState({ serverIP: newServerUrl }, () => {
        this.props.ResetConnection(newServerUrl);
        setTimeout(() => {
          this.props.navigation.goBack(); //.navigate("Home", { refresh: true });
          this.props.updateCurrentServer(serverInfo);
          const findBuilding = this.props.appReducer.buildings.find(
            (building) => building.buildingId === buildingId
          );
          if (
            findBuilding &&
            typeof this.props.navigation.state.params.onBuildingChange ===
              "function"
          ) {
            this.props.navigation.state.params.onBuildingChange(findBuilding);
          } else {
            this.props.ForceInit(serverInfo.accessToken, buildingId);
          }
        }, 500);
      });
    }
    // SecureStore.getItemAsync(CONSTS.SERVER_URL)
    //   .then((url) => {
    //     if (this.state.serverIP != url) {
    //       var oldUrlIsValid = false;
    //       if (this.state.serverIP) {
    //         oldUrlIsValid = true;
    //       }
    //       this.setState({ serverIP: url }, () => {
    //         if (oldUrlIsValid) {
    //           SecureStore.getItemAsync(CONSTS.ACCESS_TOKEN)
    //             .then((newAccessToken) => {
    //               this.props.ResetConnection(url);
    //               this.props.ForceInit(newAccessToken);

    //               setTimeout(() => {
    //                 this.props.navigation.goBack(); //.navigate("Home", { refresh: true });
    //                 if (
    //                   serverInfo &&
    //                   typeof this.props.navigation.state.params
    //                     .onServerChange == "function"
    //                 ) {
    //                   this.props.navigation.state.params.onServerChange(
    //                     serverInfo
    //                   );
    //                 }
    //               }, 500);
    //             })
    //             .catch(console.log);
    //         }
    //       });
    //     }
    //   })
    //   .catch(console.log);
  };
  logoutHandler = () => {
    this.hideLogoutConfirm();
    setTimeout(() => {
      this.props.navigation.replace("Login");
      // this.props.removerBuilding(this.props.appReducer.currentBuilding.buildingId);
      this.props.Logout();
    }, 700);
  };
  render() {
    return (
      <View style={{ flex: 1 }}>
        <ScrollView>
          {/* ServersList */}
          <SettingListItem
            title={translate("settings.server")}
            subTitle={
              translate("settings.server") +
              ": " +
              (this.state.serverIP.endsWith("/")
                ? this.state.serverIP.slice(0, -1)
                : this.state.serverIP) +
              (this.props.appReducer.connected === false
                ? `(${translate("app.connecting")})`
                : "")
            }
            onPress={() => {
              // changing server only allowed in native mobile platform and user should not be able to change server on web platform
              // this.props.navigation.navigate("ServersList", {
              //   onGoBack: async (serverInfo, buildingId = null) => {
              //     this.checkServerUrl(serverInfo, buildingId);
              //   },
              // });

              if (IS_MOBILE) {
                this.props.navigation.navigate("ServersList", {
                  onGoBack: async (
                    serverInfo,
                    buildingId = null,
                    addressConnected = ""
                  ) => {
                    this.checkServerUrl(
                      serverInfo,
                      buildingId,
                      addressConnected
                    );
                  },
                });
              }
            }}
          />

          {/* Account */}
          <SettingListItem
            title={translate("navigation.Account")}
            subTitle={this.state.fullName}
            onPress={() => {
              this.props.navigation.navigate("Account", {
                onGoBack: (fullName) => {
                  this.setState({ fullName });
                },
              });
            }}
          />

          {/* Update */}
          <SettingListItem
            showBadge={this.state.hasNewUpdate}
            title={
              this.state.hasNewUpdate
                ? translate("settings.newUpdate")
                : translate("settings.updatesHistory")
            }
            subTitle={
              this.state.hasNewUpdate
                ? translate("settings.pressToGetNewUpdate")
                : translate("settings.currentVersion", {
                    version: CONSTS.APP_VERSION,
                  })
            }
            onPress={() => {
              this.props.navigation.navigate("Updates");
            }}
          />
          {/* ===  change language === */}
          <View
            style={{
              paddingBottom: 5,
              paddingTop: 10,
              paddingHorizontal: 10,
              borderBottomColor: arTheme.COLORS.BORDER,
              borderBottomWidth: 1,
            }}
          >
            <Text
              style={{
                fontSize: 16,
                fontWeight: "bold",
                marginBottom: 5,
                fontFamily: "IRANSansWebFaNum",
              }}
            >
              {translate("app.languageTitle")}
            </Text>
            <MultiLanguage />
          </View>
          {/* Logout */}
          <SettingListItem
            title={translate("app.logout")}
            textStyle={{ color: "#F00" }}
            //subTitle={this.state.serverIP}
            onPress={() => {
              this.showLogoutConfirm();
            }}
          />

          {/* Logout Alert */}
          {this.state.isShowingLogoutAlert && (
            <AlertDialogBase
              isOpen={true}
              title={translate("app.logout")}
              confirmText={translate("app.logout")}
              colorConfirm="error"
              confirmHandler={() => {
                this.logoutHandler();
              }}
              onClose={() => {
                this.hideLogoutConfirm();
              }}
            >
              <Text>{translate("app.doYouConfirmLogout")}</Text>
            </AlertDialogBase>
          )}

          {/* ===  Sessions === */}
          <View
            style={{
              paddingBottom: 5,
              paddingTop: 10,
              paddingHorizontal: 10,
              borderBottomColor: arTheme.COLORS.BORDER,
              borderBottomWidth: 1,
            }}
          >
            <Text
              style={{
                fontSize: 16,
                fontWeight: "bold",
                marginBottom: 5,
                fontFamily: "IRANSansWebFaNum",
              }}
            >
              {translate("app.MySessions")}
            </Text>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
            >
              {this.props.userReducer.sessions?.map((s, i) => {
                return (
                  <View
                    key={s.sessionId}
                    alignItems="center"
                    containerStyle={{ flex: 1.5, width: 200 }}
                    style={{
                      borderWidth: 1,
                      borderColor: arTheme.COLORS.BORDER_COLOR,
                      borderRadius: 5,
                      padding: 2,
                      direction: getDir(),
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      numberOfLines={1}
                      style={{
                        fontSize: 12,
                        marginHorizontal: 3,
                        paddingHorizontal: 5,
                      }}
                    >
                      {i + 1}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={{
                        fontSize: 12,
                        marginHorizontal: 3,
                        paddingHorizontal: 5,
                      }}
                    >
                      {translate("app.lastActivityTime")}:
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={{
                        fontSize: 12,
                        marginHorizontal: 3,
                        paddingHorizontal: 5,
                        direction: "ltr",
                      }}
                    >
                      {s.lastActivityTime}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={{
                        fontSize: 12,
                        marginHorizontal: 3,
                        paddingHorizontal: 5,
                      }}
                    >
                      IP: {s.clientIp}
                    </Text>
                    <IconButton
                      onPress={() =>
                        this.showCloseSessionConfirm(
                          s.active ? null : s.sessionId
                        )
                      }
                      icon={{
                        code: s.active
                          ? faCharCodes.faBadgeCheck
                          : faCharCodes.faTimesCircle,
                        style: {
                          fontFamily: "FontAwesomeProLight",
                          fontSize: 18,
                          color: s.active ? "#666666" : arTheme.COLORS.ERROR,
                          padding: 8,
                          // height: 30,
                          borderWidth: 1,
                          borderColor: arTheme.COLORS.BORDER_COLOR,
                          borderRadius: 5,
                        },
                      }}
                    />
                  </View>
                );
              })}
            </View>
          </View>
          {/* Close Session Alert */}
          {this.state.isShowingCloseSessionAlert && (
            <AlertDialogBase
              isOpen={true}
              title={translate("app.CloseSession")}
              confirmText={translate("app.CloseSession")}
              colorConfirm="error"
              confirmHandler={() => {
                this.closeSession();
              }}
              onClose={() => {
                this.hideCloseSessionConfirm();
              }}
            >
              <Text>{translate("app.AreYoSureToCloseSession")}</Text>
            </AlertDialogBase>
          )}
        </ScrollView>
      </View>
    );
  }
}

class SettingListItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let _textStyle = this.props.textStyle || {};

    return (
      <TouchableHighlight
        style={{
          paddingVertical: 15,
          paddingHorizontal: 10,
          borderBottomColor: arTheme.COLORS.BORDER,
          borderBottomWidth: 1,
        }}
        onPress={() => {
          this.props.onPress && this.props.onPress();
        }}
        underlayColor="#eee"
      >
        <View>
          <View style={{ flexDirection: "row", marginBottom: 5 }}>
            {this.props.showBadge == true && (
              <Badge
                style={{
                  width: 10,
                  minWidth: 10,
                  height: 10,
                  //position: "absolute",
                  // start: 10,
                  // top: 0,
                }}
              />
            )}
            <Text style={{ fontSize: 16, fontWeight: "bold", ..._textStyle }}>
              {this.props.title}
            </Text>
          </View>

          <Text style={{ fontSize: 12, color: arTheme.COLORS.MUTED }}>
            {this.props.subTitle}
          </Text>
        </View>
      </TouchableHighlight>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appReducer: state.AppReducer,
    userReducer: state.UserReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ResetConnection: (newServerUrl) =>
      dispatch(AppActions.ResetConnection(newServerUrl)),
    Logout: () => dispatch(AppActions.LogOut()),
    ForceInit: (accessToken) => dispatch(AppActions.ForceInit(accessToken)),
    removerBuilding: (building) =>
      dispatch(AppActions.removerBuilding(building)),
    updateCurrentServer: (serverInfo) => {
      dispatch(AppActions.updateCurrentServer(serverInfo));
    },
    GetUserSessions: (accessToken) =>
      dispatch(UserActions.GetSessions(accessToken)),
    CloseUserSessions: (accessToken, sessionId) =>
      dispatch(UserActions.CloseSessions(accessToken, sessionId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsListScreen);
